/* eslint-disable react-refresh/only-export-components -- роутер: определения lazy-страниц рядом с экспортом router */
import { lazy } from 'react'
import { createBrowserRouter, Navigate } from 'react-router-dom'
import { RequireAdmin, RequireAnon, RequireAuth } from '@/auth/RequireAuth'
import { AppLayout } from '@/layouts/AppLayout'

// Все страницы лениво — bundle splitting.
const LoginPage = lazy(() => import('@/pages/LoginPage').then((m) => ({ default: m.LoginPage })))
const ProfilePage = lazy(() =>
  import('@/pages/ProfilePage').then((m) => ({ default: m.ProfilePage })),
)
const VpnPage = lazy(() => import('@/pages/VpnPage').then((m) => ({ default: m.VpnPage })))
const SecurityPage = lazy(() =>
  import('@/pages/SecurityPage').then((m) => ({ default: m.SecurityPage })),
)
const RegisterPage = lazy(() =>
  import('@/pages/RegisterPage').then((m) => ({ default: m.RegisterPage })),
)
const RecoveryPage = lazy(() =>
  import('@/pages/RecoveryPage').then((m) => ({ default: m.RecoveryPage })),
)
const UsersPage = lazy(() =>
  import('@/pages/admin/UsersPage').then((m) => ({ default: m.UsersPage })),
)
const UserEditPage = lazy(() =>
  import('@/pages/admin/UserEditPage').then((m) => ({ default: m.UserEditPage })),
)
const GroupsPage = lazy(() =>
  import('@/pages/admin/GroupsPage').then((m) => ({ default: m.GroupsPage })),
)
const GroupEditPage = lazy(() =>
  import('@/pages/admin/GroupEditPage').then((m) => ({ default: m.GroupEditPage })),
)
const OutboundsPage = lazy(() =>
  import('@/pages/admin/OutboundsPage').then((m) => ({ default: m.OutboundsPage })),
)
const OutboundEditPage = lazy(() =>
  import('@/pages/admin/OutboundEditPage').then((m) => ({ default: m.OutboundEditPage })),
)
const NotFoundPage = lazy(() =>
  import('@/pages/NotFoundPage').then((m) => ({ default: m.NotFoundPage })),
)

export const router = createBrowserRouter([
  {
    element: <RequireAnon />,
    children: [
      { path: '/login', element: <LoginPage /> },
      // Регистрация по приглашению и восстановление доступа — публичные: у человека ещё
      // нет ни ключа, ни сессии.
      { path: '/register', element: <RegisterPage /> },
      { path: '/recovery', element: <RecoveryPage /> },
    ],
  },
  {
    element: <RequireAuth />,
    children: [
      {
        element: <AppLayout />,
        children: [
          { index: true, element: <Navigate to="/profile" replace /> },
          { path: 'profile', element: <ProfilePage /> },
          { path: 'vpn', element: <VpnPage /> },
          { path: 'security', element: <SecurityPage /> },
          {
            element: <RequireAdmin />,
            children: [
              { path: 'admin/users', element: <UsersPage /> },
              // Приглашения переехали разделом на страницу пользователей. Старый адрес
              // остаётся редиректом: он был в навигации и мог осесть в закладках, а `*`
              // отдал бы 404 вместо переехавшего списка.
              { path: 'admin/invites', element: <Navigate to="/admin/users" replace /> },
              { path: 'admin/users/:userId', element: <UserEditPage /> },
              { path: 'admin/groups', element: <GroupsPage /> },
              { path: 'admin/groups/:groupId', element: <GroupEditPage /> },
              { path: 'admin/outbounds', element: <OutboundsPage /> },
              { path: 'admin/outbounds/:outboundId', element: <OutboundEditPage /> },
            ],
          },
        ],
      },
    ],
  },
  { path: '*', element: <NotFoundPage /> },
])
